// Minimal shape of react-router's navigate function (typed locally because the
// installed react-router beta doesn't export NavigateFunction).
type Navigate = (to: string, options?: { replace?: boolean }) => void;

// Holds the router's navigate function so non-React code (e.g. Axios
// interceptors) can do client-side navigation without a full page reload.
let navigator: Navigate | null = null;

export const setNavigator = (nav: Navigate) => {
  navigator = nav;
};

export const navigateTo = (path: string) => {
  if (navigator) {
    navigator(path);
  } else {
    // Fallback if navigation is triggered before the router has registered.
    window.location.assign(path);
  }
};
